"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SUPPORTED_CURRENCIES = exports.SALESFORCE_LEAD_SOURCE = exports.LAZY_LOAD_OFFSET = exports.INTERCOM_LEAD_SOURCE = exports.EASING = exports.CARD_SLIDER_TYPES = exports.CARD_SLIDER_CARD_SIZES = void 0;
var EASING = exports.EASING = {
  BOUNCE: function BOUNCE() {
    return 'cubic-bezier(0.175, 0.885, 0.32, 1.275)';
  }
};
var CARD_SLIDER_TYPES = exports.CARD_SLIDER_TYPES = {
  NON_FULL_WIDTH: 'non-full-width'
};
var CARD_SLIDER_CARD_SIZES = exports.CARD_SLIDER_CARD_SIZES = {
  SMALL_SQUARE: 'small--square',
  XS_WIDE: 'xs--wide'
};
var SUPPORTED_CURRENCIES = exports.SUPPORTED_CURRENCIES = ['EUR', 'USD', 'GBP', 'AUD', 'CAD'];
var LAZY_LOAD_OFFSET = exports.LAZY_LOAD_OFFSET = '200px';

// Legacy - moving to Intercom
var SALESFORCE_LEAD_SOURCE = exports.SALESFORCE_LEAD_SOURCE = {
  GROUP_BOOKINGS: 'Group Bookings',
  TSW_CONTACT_US: 'TSW Contact form',
  YNF_CONTACT_US: 'YNF Contact form',
  DAY8_CONTACT_US: 'Day 8 Contact form'
};
var INTERCOM_LEAD_SOURCE = exports.INTERCOM_LEAD_SOURCE = {
  TYW_CONTACT_US: 'TYW Contact form',
  TYW_GROUP_BOOKINGS: 'TYW Group Bookings',
  TSW_CONTACT_US: 'TSW Contact form',
  YNF_CONTACT_US: 'YNF Contact form',
  DAY8_CONTACT_US: 'Day 8 Contact form'
};